export const advantagesContent = {
    list: [
        'просыпайтесь под шум сосен <br/>и гуляйте по собственной набережной, <span>не теряя связи с городом</span>',
    ],
};
